import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCouponBuyCrypto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M3.25 13a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM15.25 17a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M21.75 20A1.75 1.75 0 0 1 20 21.75H5A1.75 1.75 0 0 1 3.25 20V10c0-.966.783-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v10Zm-1.75.25a.25.25 0 0 0 .25-.25V10a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h15Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.057 13.88a.854.854 0 0 1-1.003-.672l-1.08-5.49a1.992 1.992 0 0 1 1.57-2.34l11.453-2.253a1.992 1.992 0 0 1 2.338 1.561l.815 4.045a.854.854 0 1 1-1.673.338l-.816-4.045a.285.285 0 0 0-.334-.223L3.874 7.053a.285.285 0 0 0-.224.335l1.08 5.49a.854.854 0 0 1-.673 1.003Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.05.378.361.668.742.69l-.028.005a.895.895 0 0 0-.722.745.834.834 0 0 0-.681-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
  </svg>
);
export default SvgTwoColorCouponBuyCrypto;
